<div class="app-company-wrapper">
  <router-outlet></router-outlet>
</div>
